import { TranslatedCalling } from './common';

export const fetch_sparks = {
  type: 'thinking',
  call: () => <TranslatedCalling i18nKey="tool.fetch-sparks.checking" />,
  'partial-call': () => <TranslatedCalling i18nKey="tool.fetch-sparks.checking" />,
  result: () => null,
};
